<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
  >
    <div
      class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between"
    >
      <div class="trezo-card-title">
        <h5 class="mb-0">Attachments</h5>
      </div>
    </div>

    <div class="trezo-card-content">
      <ul>
        <li
          class="rounded-md flex justify-between items-center bg-gray-50 dark:bg-[#15203c] p-[15px] mb-[10px] last:mb-0"
        >
          <div class="flex items-center">
            <div
              class="bg-white dark:bg-[#0c1427] text-primary-500 rounded-full text-center leading-[40px] text-[22px] w-[40px] h-[40px]"
            >
              <i class="ri-file-warning-line"></i>
            </div>
            <div class="ltr:ml-[12px] rtl:mr-[12px]">
              <h6 class="text-base mb-[3px] font-medium">
                Project_attachment_1.zip
              </h6>
              <span class="block text-sm"> 3.25 MB </span>
            </div>
          </div>
          <button
            type="button"
            class="leading-none text-primary-500 text-[22px]"
          >
            <i class="ri-download-2-line"></i>
          </button>
        </li>
        <li
          class="rounded-md flex justify-between items-center bg-gray-50 dark:bg-[#15203c] p-[15px] mb-[10px] last:mb-0"
        >
          <div class="flex items-center">
            <div
              class="bg-white dark:bg-[#0c1427] text-primary-500 rounded-full text-center leading-[40px] text-[22px] w-[40px] h-[40px]"
            >
              <i class="ri-file-warning-line"></i>
            </div>
            <div class="ltr:ml-[12px] rtl:mr-[12px]">
              <h6 class="text-base mb-[3px] font-medium">
                Project_attachment_2.zip
              </h6>
              <span class="block text-sm"> 5.12 MB </span>
            </div>
          </div>
          <button
            type="button"
            class="leading-none text-primary-500 text-[22px]"
          >
            <i class="ri-download-2-line"></i>
          </button>
        </li>
        <li
          class="rounded-md flex justify-between items-center bg-gray-50 dark:bg-[#15203c] p-[15px] mb-[10px] last:mb-0"
        >
          <div class="flex items-center">
            <div
              class="bg-white dark:bg-[#0c1427] text-primary-500 rounded-full text-center leading-[40px] text-[22px] w-[40px] h-[40px]"
            >
              <i class="ri-file-warning-line"></i>
            </div>
            <div class="ltr:ml-[12px] rtl:mr-[12px]">
              <h6 class="text-base mb-[3px] font-medium">
                Project_attachment_3.zip
              </h6>
              <span class="block text-sm"> 5.12 MB </span>
            </div>
          </div>
          <button
            type="button"
            class="leading-none text-primary-500 text-[22px]"
          >
            <i class="ri-download-2-line"></i>
          </button>
        </li>
        <li
          class="rounded-md flex justify-between items-center bg-gray-50 dark:bg-[#15203c] p-[15px] mb-[10px] last:mb-0"
        >
          <div class="flex items-center">
            <div
              class="bg-white dark:bg-[#0c1427] text-primary-500 rounded-full text-center leading-[40px] text-[22px] w-[40px] h-[40px]"
            >
              <i class="ri-file-warning-line"></i>
            </div>
            <div class="ltr:ml-[12px] rtl:mr-[12px]">
              <h6 class="text-base mb-[3px] font-medium">
                Project_attachment_4.zip
              </h6>
              <span class="block text-sm"> 3.43 MB </span>
            </div>
          </div>
          <button
            type="button"
            class="leading-none text-primary-500 text-[22px]"
          >
            <i class="ri-download-2-line"></i>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Attachments",
});
</script>
